import type {DoctorResult} from './actions/doctor-actions';

import chalk from 'chalk';
import {Command} from 'commander';
import inquirer from 'inquirer';

import {runDoctor} from './actions/doctor-actions';
import {getCurrentVersion, showVersion} from './actions/get-version';
import {initBackend} from './actions/init-backend';
import {initFrontend} from './actions/init-frontend';
import {initMobile} from './actions/init-mobile';

type ProjectType = 'backend' | 'frontend' | 'mobile';

interface CLIOptions {
  init?: ProjectType;
  template_name?: string;
  doctor?: boolean;
}

const program = new Command();

program
  .name('miregen')
  .description('Miregen CLI for generating project templates')
  .version(getCurrentVersion(), '-v, --version', 'Show CLI version')
  .option('--init <type>', 'Initialize a project type: backend|frontend|mobile')
  .option('--template_name <name>', 'Select a specific template')
  .option('--doctor', 'Check your environment setup');

program.parse(process.argv);
const options = program.opts<CLIOptions>();

const runDoctorCLI = (): void => {
  const results: DoctorResult[] = runDoctor();

  results.forEach((r) => {
    const line = r.ok ? chalk.green(r.message) : chalk.red(r.message);

    process.stdout.write(line + '\n');
  });

  const allOk = results.every((r) => r.ok);
  const finalMessage = allOk
    ? chalk.green('All checks passed ✅')
    : chalk.red('Some checks failed ❌');

  process.stdout.write(finalMessage + '\n');
};

const showMenu = async (): Promise<void> => {
  const {action} = await inquirer.prompt<{action: string}>([
    {
      choices: [
        'Backend',
        'Frontend',
        'Mobile',
        new inquirer.Separator(),
        chalk.green('Doctor'),
        chalk.blue('Version')
      ],
      message: 'Select an option:',
      name: 'action',
      type: 'list'
    }
  ]);

  switch (action) {
    case 'Backend':
      await initBackend();
      break;
    case 'Frontend':
      await initFrontend();
      break;
    case 'Mobile':
      await initMobile();
      break;
    case chalk.green('Doctor'):
      runDoctorCLI();
      break;
    case chalk.blue('Version'):
      await showVersion();
      break;
    default:
      process.stderr.write(chalk.red('Invalid selection\n'));
      break;
  }
};

const runDirect = async (): Promise<void> => {
  if (options.init) {
    const type = options.init.toLowerCase() as ProjectType;

    if (!['backend', 'frontend', 'mobile'].includes(type)) {
      process.stderr.write(chalk.red('Invalid project type! Use backend|frontend|mobile\n'));
      process.exit(1);
    }

    switch (type) {
      case 'backend':
        await initBackend();
        break;
      case 'frontend':
        await initFrontend();
        break;
      case 'mobile':
        await initMobile();
        break;
    }
  } else if (options.doctor) {
    runDoctorCLI();
  } else {
    await showMenu();
  }
};

runDirect().catch((err: unknown) => {
  process.stderr.write(
    chalk.red(`CLI error: ${err instanceof Error ? err.message : String(err)}\n`)
  );
  process.exit(1);
});
